import { DeviceId } from './../../tracking/constants/DeviceId';
import { TrackingEventIds } from './../../tracking/constants/TrackingEventIds';
/**
 * Created by rkamysz on 6/19/2015.
 */


import { EnvGlobalsHandler } from "../EnvGlobalsHandler";
import { BasicModel } from "../model/BasicModel";
import { Capabilities } from "@goodgamestudios/createjs-utilities";
import { PerformanceMonitoringService } from '../../profiling/service/PerformanceMonitoringService';

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("BasicGameData");

export class BasicGameData {
    constructor() {
    }

    public get eventId(): number {
        return TrackingEventIds.IN_GAME_PERFORMANCE;
    }

    public get gameId(): number {
        return EnvGlobalsHandler.globals.gameId;
    }

    public get networkId(): number {
        return EnvGlobalsHandler.globals.networkId;
    }

    public get instanceId(): number {
        return BasicModel.instanceProxy.selectedInstanceVO.instanceId;
    }

    public get playerId(): number {
        return BasicModel.userData.playerID;
    }

    public get sessionId(): number {
        return Number(EnvGlobalsHandler.globals.sessionId);
    }

    public get sessionTime(): number {
        return Math.floor(EnvGlobalsHandler.globals.sessionLength);
    }

    public get date(): number {
        return new Date().getTime() / 1000;
    }

    public get level(): number {
        return BasicModel.userData.userLevel;
    }

    public get deviceId(): number {
        return DeviceId.DESKTOP;
    }

    public get storeId(): number {
        return 0;
    }

    public get memoryUsage(): number {
        logger.warn("memory usage not available");
        return 0;
        // TODO @HTML5 //        return PerformanceMonitoringService.getInstance().performanceMonitoringProxy.averageMeasurementResults.averageTotalMemoryUsageInMB;
    }

    public get buildVersion(): number {
        return Number(EnvGlobalsHandler.globals.versionInformation.versionNumberGame.replace(/\D/g, ""));
    }

    public get lang(): string {
        return Capabilities.language;
    }

    public get connectionType(): string {
        return "";
    }
}
